import { render, staticRenderFns } from "./SettingsBotCreate.vue?vue&type=template&id=71a103a6&"
import script from "./SettingsBotCreate.vue?vue&type=script&lang=js&"
export * from "./SettingsBotCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports